import React from 'react';

import type { DocNode } from '@atlaskit/adf-schema';
import type { ProviderFactory } from '@atlaskit/editor-common/provider-factory';
import { ReactRenderer } from '@atlaskit/renderer';
import { RendererActionsContext } from '@atlaskit/renderer/actions';

type Props = {
	promptADF: string;
	providerFactory: ProviderFactory;
};

export const LatestPromptRenderer = ({ promptADF, providerFactory }: Props) => {
	const jsonDocument = JSON.parse(promptADF) as DocNode;

	return (
		<RendererActionsContext>
			<ReactRenderer
				document={jsonDocument}
				media={{
					// We don't currently support images with captions
					allowLinking: false,
				}}
				// By default -- the renderer uses a "default schema" which supports all
				// the nodes and marks the markdown transformer can create.
				// see packages/editor/adf-schema/src/schema/default-schema.ts for details.
				useSpecBasedValidator
				dataProviders={providerFactory}
			/>
		</RendererActionsContext>
	);
};
